/**
 * Purchase Page Sections
 * 
 * Registers all section components for the generic purchase page with the section registry.
 * Each section is auto-registered at module load time so they're available to the
 * section dispatcher in PurchasePage.
 */

import { registerSectionComponent } from '../../../config/sectionRegistry';
import PurchaseHeroSection from './PurchaseHeroSection';
import PurchasePartnerSelectorSection from './PurchasePartnerSelectorSection';
import PurchaseTicketSelectorSection from './PurchaseTicketSelectorSection';
import PurchaseWeeksSelectorSection from './PurchaseWeeksSelectorSection';
import PurchasePaymentSection from './PurchasePaymentSection';
import PurchaseCharityCardSection from './PurchaseCharityCardSection';
import PurchaseTrustFooterSection from './PurchaseTrustFooterSection';
import PurchaseCardSelectorSection from './PurchaseCardSelectorSection';

// Register purchase_hero
registerSectionComponent(
  'purchase_hero',
  PurchaseHeroSection,
  {
    category: 'hero',
    label: 'Purchase Hero',
    description: 'Top hero banner with jackpot and countdown',
    icon: '🎯',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_ticket_selector
registerSectionComponent(
  'purchase_ticket_selector',
  PurchaseTicketSelectorSection,
  {
    category: 'game',
    label: 'Ticket Selector',
    description: 'Package selection and quantity controls',
    icon: '🎟️',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_weeks_selector (Modified 50/50 only; self-hides for others)
registerSectionComponent(
  'purchase_weeks_selector',
  PurchaseWeeksSelectorSection,
  {
    category: 'game',
    label: 'Weeks Selector',
    description: 'Multi-week selector — shown for Modified 50/50 only',
    icon: '📅',
    supportedPages: ['purchase'],
    defaultConfig: { maxWeeks: 52 },
  }
);

// Register purchase_partner_selector
registerSectionComponent(
  'purchase_partner_selector',
  PurchasePartnerSelectorSection,
  {
    category: 'charity',
    label: 'Partner Selector',
    description: 'Partner selection card for attributed ticket purchasing',
    icon: '🤝',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_payment
registerSectionComponent(
  'purchase_payment',
  PurchasePaymentSection,
  {
    category: 'utility',
    label: 'Payment Checkout',
    description: 'Payment form and order summary',
    icon: '💳',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_card_selector (Chase the Ace only; self-hides for others)
registerSectionComponent(
  'purchase_card_selector',
  PurchaseCardSelectorSection,
  {
    category: 'game',
    label: 'Card Selector',
    description: 'CTA card picker — shown for Chase the Ace only',
    icon: '🃏',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_charity_card
registerSectionComponent(
  'purchase_charity_card',
  PurchaseCharityCardSection,
  {
    category: 'charity',
    label: 'Charity Card',
    description: 'Charity information sidebar',
    icon: '❤️',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Register purchase_trust_footer
registerSectionComponent(
  'purchase_trust_footer',
  PurchaseTrustFooterSection,
  {
    category: 'promo',
    label: 'Trust Signals',
    description: 'Security and trust badges',
    icon: '🛡️',
    supportedPages: ['purchase'],
    defaultConfig: {},
  }
);

// Export all components for direct import if needed
export {
  PurchaseHeroSection,
  PurchasePartnerSelectorSection,
  PurchaseTicketSelectorSection,
  PurchaseWeeksSelectorSection,
  PurchaseCardSelectorSection,
  PurchasePaymentSection,
  PurchaseCharityCardSection,
  PurchaseTrustFooterSection,
};

// Export context for use in PurchasePage
export { PurchasePageProvider, usePurchasePage } from './PurchasePageContext';
